import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

// Components
import CreateLinks from "./CreateLinks";
import SuccessWrap from "../../utils/error-success/SuccessWrap";
import ErrorWrap from "../../utils/error-success/ErrorWrap";
import Button from "../../utils/Button";

// State
import { registerAccount, resetUpdateAccountSuccess } from "../../../store/actions/user";

class CreateForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fname: props.customer ? props.customer.fname : "",
			lname: props.customer ? props.customer.lname : "",
			email: props.customer ? props.customer.email : "",
			phone: props.customer ? props.customer.phone : "",
			comments: props.customer ? props.customer.comments : "",
			maxCommentLength: 255
		};
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentWillUnmount() {
		this.props.resetUpdateAccountSuccess();
	}

	// ===================================
	//  INPUT HANLDING
	// ===================================
	handleInputChange(event) {
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.handleSubmit();
		}
	}

	// ===================================
	//  SUBMIT
	// ===================================
	handleSubmit = () => {
		this.props.registerAccount(this.state);
	};

	// ===================================
	//  RENDER
	// ===================================
	render() {
		const { translations, accountUpdateSuccess, errors } = this.props;

		return (
			<React.Fragment>
				{accountUpdateSuccess && (
					<SuccessWrap animate={1}>
						{translations.sections.reviewer_registration_form.success_message}
					</SuccessWrap>
				)}

				<div className="floated-field-container">
					<div className="form-field half-field">
						<label htmlFor="fname">
							{translations.sections.reviewer_registration_form.fname}:
						</label>

						{errors.fname && <ErrorWrap animate={1}>{errors.fname}</ErrorWrap>}
						<input
							type="text"
							id="fname"
							value={this.state.fname}
							placeholder={
								translations.sections.reviewer_registration_form.fname_placeholder
							}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={e => this.handleInputChange(e)}
						/>
					</div>

					<div className="form-field half-field">
						<label htmlFor="lname">
							{translations.sections.reviewer_registration_form.lname}:
						</label>

						{errors.lname && <ErrorWrap animate={1}>{errors.lname}</ErrorWrap>}
						<input
							type="text"
							id="lname"
							value={this.state.lname}
							placeholder={
								translations.sections.reviewer_registration_form.lname_placeholder
							}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={e => this.handleInputChange(e)}
						/>
					</div>
				</div>

				<div className="floated-field-container">
					<div className="form-field half-field">
						<label htmlFor="email">
							{translations.sections.reviewer_registration_form.email}:
						</label>

						{errors.email && <ErrorWrap animate={1}>{errors.email}</ErrorWrap>}
						<input
							type="email"
							id="email"
							value={this.state.email}
							placeholder={
								translations.sections.reviewer_registration_form.email_placeholder
							}
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={e => this.handleInputChange(e)}
						/>
					</div>

					<div className="form-field half-field">
						<label htmlFor="phone">
							{translations.sections.reviewer_registration_form.phone}:
						</label>

						{errors.phone && <ErrorWrap animate={1}>{errors.phone}</ErrorWrap>}
						<NumberFormat
							id="phone"
							placeholder={
								translations.sections.reviewer_registration_form.phone_placeholder
							}
							value={this.state.phone}
							type="tel"
							format="### ### ####"
							mask="_"
							onKeyPress={e => this.handleKeyPress(e)}
							onChange={e => this.handleInputChange(e)}
						/>
					</div>
				</div>

				<div className="form-field">
					<label htmlFor="comments">
						{translations.sections.reviewer_registration_form.reason}:
					</label>

					{errors.comments && <ErrorWrap animate={1}>{errors.comments}</ErrorWrap>}
					<textarea
						value={this.state.comments}
						id="comments"
						onChange={event => this.handleInputChange(event)}
						maxLength={this.state.maxCommentLength}
					/>
				</div>

				<div className="btn_container pt1">
					{errors.general && <ErrorWrap animate={1}>{errors.general}</ErrorWrap>}
					<Button
						text={translations.sections.reviewer_registration_form.register_button}
						classes={"submit-btn"}
						clickHandler={this.handleSubmit}
						{...this.props}
					/>
				</div>

				<CreateLinks />
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		errors: state.user.errors,
		isLoading: state.user.isLoading,
		accountUpdateSuccess: state.user.accountUpdateSuccess
	};
};

export default connect(
	mapStateToProps,
	{ registerAccount, resetUpdateAccountSuccess }
)(CreateForm);



// WEBPACK FOOTER //
// ./src/components/reviewer/create/CreateForm.js